export const API_URL = 'https://aacasipit.dev'
export const DATETIME_REGEX = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(.\d+)?Z/g

export const API_ACCESS_KEY = 'nivos-api-access-key'

export const API_REFRESH_KEY = 'nivos-api-refresh-key'

export const DOC_VIEWER_SUPPORTED_FILES: string[] = [
  'BMP',
  'DOC',
  'DOCX',
  'HTM',
  'HTML',
  'JPG',
  'JPEG',
  'PDF',
  'PNG',
  'PPT',
  'PPTX',
  'TIFF',
  'TXT',
  'XLS',
  'XLSX'
]
